{
  "adobeExperienceCloudNoOrgsSelect": "Sélectionner le compte d’une autre organisation",
  "adobeExperienceCloudSelectedOrg": "Organisation sélectionnée : {org}",
  "appSwitcherLinkOutIconLabel": "S’ouvre dans une nouvelle fenêtre",
  "feedback button default": "Commentaires",
  "help": "Aide",
  "launchsidebar": "Lancer la barre latérale",
  "more actions": "Plus d’actions",
  "searchButton": "Rechercher",
  "solutionSwitcher": "Passer à une autre solution",
  "solutionSwitcherList": "Liste des applications",
  "solutionSwitcherPopover": "Fenêtre contextuelle Liste des applications"
}
